;(function () {
  // Global-e integration hook for footer localization selector.
  // Return true when handled by Global-e to prevent Shopify fallback submit.
  window.trHandleGlobalECountryChange = function (detail) {
    if (!detail || !detail.countryCode) return false;

    return false;
  };
})();
